import { BookingList } from "./booking-list";
import { BookingSchedule } from "./booking-schedule";
export class BookingRefund extends BookingList {
    paymentIntentId: string;
    addons: any[] = [];
    static mapFromBookingList(booking: BookingList): BookingRefund {
        const refund = new BookingRefund();
        refund.id = booking.id;
        refund.startTime = booking.startTime;
        refund.endTime = booking.endTime;
        refund.status = booking.status;
        refund.simulatorId = booking.simulatorId;
        refund.bayName = booking.bayName;
        refund.bayNumber = booking.bayNumber;
        refund.confirmationNumber = booking.confirmationNumber;
        refund.participants = booking.participants;
        refund.totalPrice = booking.totalPrice;
        refund.priceOverride = booking.priceOverride;
        refund.priceOverrideReason = booking.priceOverrideReason;
        refund.hasPaid = booking.hasPaid;
        refund.phoneNumber = booking.phoneNumber;
        refund.email = booking.email;
        refund.customerName = booking.customerName;
        refund.refundAmount = booking.refundAmount;
        refund.refundReason = booking.refundReason;
        refund.stripePaymentIntentId = booking.stripePaymentIntentId;
        return refund;
    }

    static mapFromBookingSchedule(booking: BookingSchedule, refundAmount: number, refundReason: string, participants: number): BookingRefund {
        const refund = new BookingRefund();
        refund.id = booking.id;
        refund.startTime = booking.startTime;
        refund.endTime = booking.endTime;
        refund.status = booking.status;
        refund.simulatorId = booking.simulatorId;
        refund.bayName = booking.bayName;
        refund.bayNumber = booking.bayNumber;
        refund.confirmationNumber = booking.confirmationNumber;
        refund.participants = participants;
        refund.totalPrice = booking.totalPrice;
        refund.priceOverride = booking.priceOverride;
        refund.priceOverrideReason = booking.priceOverrideReason;
        refund.hasPaid = booking.hasPaid;
        refund.phoneNumber = booking.phoneNumber;
        refund.email = booking.email;
        refund.customerName = booking.customerName;
        refund.refundAmount = refundAmount;
        refund.refundReason = refundReason;
        refund.lastEditedBy = booking.lastEditedBy;
        refund.organizationId = booking.organizationId;
        refund.stripePaymentIntentId = booking.stripePaymentIntentId;
        return refund;
    }
}